export const Marquee = ({ items }) => (
  <div className="marquee" data-testid="editorial-marquee" aria-hidden="true">
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div className="marquee-group" key={copy}>
          {items.map((item) => (
            <span className="marquee-item" key={`${copy}-${item}`}>
              {item}
              <i />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
